<div class="form-pagos ">
  <form (ngSubmit)="validateUser(validateUserForm.value)" [formGroup]="validateUserForm" *ngIf="!affiliation && !noAffiliateCompany && validation">
    <div class="form--section form--section-icon--line form--section-icon section ">
      <em class="form-icon form-icon-left material-icons {{docIsSelect?'active-form-icon':''}} none-icon">subtitles</em>
      <div class="d-flex bottom-xs m-t-30">
        <label for="idTypePerson" [ngClass]="{'color-gray': individualQuery}" class="inactive-color header-card_title u-medium f-16 t-align-initial">
          Tipo de documento
            <!--<select class="input--regular p-top-24" formControlName="idTypePerson" id="idTypePerson"
              (change)="changeSelectDocumentType($event.target.value)" required>
              <option value="" disabled selected>Tipo de documento</option>
              <option *ngFor="let documentTypeP of documentTypePerson" [value]="documentTypeP.value">
                {{documentTypeP.name}}
              </option>
            </select>-->
        </label>

      </div>

      <div class="filter-card--select--content">
        <select  tabindex="0" class="input--regular p-top-24" formControlName="idTypePerson" id="idTypePerson"
        [ngClass]="{hasError: validateUserForm.get('idTypePerson').errors &&
                  validateUserForm.get('idTypePerson').touched}"
        (change)="changeSelectDocumentType($event.target.value)" required>
        <option value="" disabled selected>Tipo de documento</option>
        <option *ngFor="let documentTypeP of documentTypePerson" [value]="documentTypeP.value">
          {{documentTypeP.name}}
        </option>
      </select>
      </div>

      <app-form-errors *ngIf="validateUserForm.get('idTypePerson').touched"
        [errors]="validateUserForm.get('idTypePerson').errors">
        Campo obligatorio
      </app-form-errors>
    </div>

    <div class="form--section form--section-icon section mg-btm-30 m-0">
      <em class="form-icon form-icon-left material-icons {{numDocIsFill?'active-form-icon':''}} none-icon">dialpad</em>
      <div class="header-card d-flex bottom-xs">
        <label for="idPerson" [ngClass]="{'color-gray': individualQuery}" class="inactive-color header-card_title u-medium f-16 t-align-initial">Número
          de documento</label>
      </div>
      <div class="section">
        <input  tabindex="0" type="text" (keyup)="keyPressNumDoc($event.target.value)" formControlName="idPerson" id="idPerson"
          (blur)="focusNext()"
           class="input--regular" placeholder="Número de documento"
           [ngClass]="{hasError: validateUserForm.get('idPerson').errors &&
                  validateUserForm.get('idPerson').touched}">
      </div>
      <app-form-errors *ngIf="validateUserForm.get('idPerson').touched"
        [errors]="validateUserForm.get('idPerson').errors">
        Campo obligatorio
      </app-form-errors>
    </div>

    <div class="form--section-icon pad-sm-none d-flex text-center m-b-32">
      <button  tabindex="0" type="submit" title="Siguiente" id="btn-siguiente"
      appDebounceClickGeneral #btnConsultar
      attr.data-category = "{{analyticsModel.category}}"
      attr.data-action ="{{analyticsModel.action}}"
      attr.data-label = "{{analyticsModel.label}}"
      attr.data-event = "{{analyticsModel.event}}"
      [disabled]="!validateUserForm.valid || processing"
        [className]="individualQuery ? 'u-btn u-btn--blue u-btn--small u-btn-i mg-btm-30 bnt-datail bnt-datail--blue' : 'inactive-buttom u-btn-i mg-btm-30 bnt-datail bnt-datail--blue'">
        <!--<em class="material-icons">navigate_next</em>-->
        <span class="text-btn-datail">{{ processing? 'Validando..' : analyticsModel.label}}</span>
      </button>
    </div>
  </form>
</div>

<div class="row justify-content-center mg-top-20" *ngIf="affiliation && !validation">
  <div class="d-flex col-xs-12 col-md-10 ">
    <div class="card card--one bg-white mg-btm-30 col-xs-12">
      <div class="icon-living-place icon-living-place-error shadow-item text-center">
        <em class="material-icons color-red">cancel</em>
      </div>
      <div class="mg-btm-30 mg-top-20 text-center">
        <span class="mg-btm-30 color-blue-light">
          <!-- {{afiliadoData?.primerNombre}} {{afiliadoData?.primerApellido}} ¡Ya está afiliado(a)! -->
          El usuario que esta consultando ya se encuentra afiliado con su empresa.
        </span>
      </div>
      <!-- /list-data -->
      <div class="col-xs-12 p-0">
        <div class="form--section-icon pad-sm-none d-flex justify-content-center text-center">
          <div class="col-xs-12 col-sm-6 p-0">
            <a [routerLink]="'/'+inicio" title="Volver a pantalla de inicio" id="Validate-User-GoToHome"
              class="u-btn--light u-btn u-btn--line u-btn--small u-btn--icon mg-btm-30">Volver a inicio</a>
          </div>
          <div class="col-xs-12 col-sm-6 p-0">
            <a (click)="otherAffiliate()" title="Afiliar otro empleado" id="Validate-User-Other-Affiliate" class="u-btn--light u-btn u-btn--blue u-btn--small u-btn--icon mg-btm-30"><em
                class="material-icons">keyboard_arrow_right</em>Afiliar otro empleado</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row justify-content-center mg-top-20 m-t-50" *ngIf="noAffiliateCompany && !validation">
    <div class="d-flex col-xs-12 col-md-10 ">
      <div class="card card--one bg-white mg-btm-30 col-xs-12">
        <div class="icon-living-place icon-living-place-error shadow-item text-center">
          <em class="material-icons color-red">cancel</em>
        </div>
        <div class="mg-btm-30 mg-top-20 text-center">
          <span class="mg-btm-30 color-blue-light">
          <!--<p style="color:red;"><b>IMPORTANTE</b></p>-->
            <!-- {{afiliadoData?.primerNombre}} {{afiliadoData?.primerApellido}} ¡Ya está afiliado(a)! -->
            <!--El trabajador no se encuentra afiliado a su empresa.-->
            <p>En este momento no podemos realizar la consulta. Si acabas de afiliar al trabajador, recuerda que debes esperar 15 minutos para consultarlo</p>
          </span>
        </div>
        <!-- /list-data -->
        <div class="col-xs-12">
          <div class="form--section-icon pad-sm-none d-flex justify-content-center text-center no-padding-left">
            <div class="col-xs-12">
              <a [routerLink]="'/'+inicio" title="Volver a pantalla de inicio"
                class="u-btn--light u-btn u-btn--line u-btn--small u-btn--icon mg-btm-30">Volver a inicio</a>
            </div>
            <div class="col-xs-12">
              <a (click)="otherAffiliate()" href="javascript:;" id="Validate-User-Other" title="Consultar otro empleado"
                  class="u-btn--light u-btn u-btn--blue u-btn--small u-btn--icon mg-btm-30"><em
                  class="material-icons">keyboard_arrow_right</em>Consultar otro empleado</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
